function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Groupe_4",
  "data-name": "Groupe 4"
}, /*#__PURE__*/React.createElement("g", {
  id: "Groupe_3",
  "data-name": "Groupe 3"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_3",
  "data-name": "Trac\\xE9 3",
  d: "M28.836,2.552H27.305V0H24.753V2.552H7.911V0H5.359V2.552H3.828A3.832,3.832,0,0,0,0,6.38V28.836a3.832,3.832,0,0,0,3.828,3.828H28.836a3.832,3.832,0,0,0,3.828-3.828V6.38A3.832,3.832,0,0,0,28.836,2.552Zm1.276,26.285a1.277,1.277,0,0,1-1.276,1.276H3.828a1.277,1.277,0,0,1-1.276-1.276V11.994H30.112Zm0-19.394H2.552V6.38A1.277,1.277,0,0,1,3.828,5.1H5.359V7.656H7.911V5.1H24.753V7.656h2.552V5.1h1.531A1.277,1.277,0,0,1,30.112,6.38Z",
  fill: "#676767"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Groupe_6",
  "data-name": "Groupe 6",
  transform: "translate(4.732 14.859)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Groupe_5",
  "data-name": "Groupe 5",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_5",
  "data-name": "Rectangle 5",
  width: 3,
  height: 4,
  transform: "translate(-0.174)",
  fill: "#676767"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Groupe_8",
  "data-name": "Groupe 8",
  transform: "translate(11.732 14.859)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Groupe_7",
  "data-name": "Groupe 7",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_6",
  "data-name": "Rectangle 6",
  width: 1,
  height: 4,
  transform: "translate(-0.174)",
  fill: "#676767"
})));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Groupe_10",
  "data-name": "Groupe 10",
  transform: "translate(14.732 14.859)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Groupe_9",
  "data-name": "Groupe 9",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7",
  "data-name": "Rectangle 7",
  width: 4,
  height: 4,
  transform: "translate(-0.174)",
  fill: "#676767"
})));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "Groupe_12",
  "data-name": "Groupe 12",
  transform: "translate(19.732 14.859)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Groupe_11",
  "data-name": "Groupe 11",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_8",
  "data-name": "Rectangle 8",
  width: 4,
  height: 4,
  transform: "translate(-0.174)",
  fill: "#676767"
})));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  id: "Groupe_14",
  "data-name": "Groupe 14",
  transform: "translate(26.732 14.859)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Groupe_13",
  "data-name": "Groupe 13",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_9",
  "data-name": "Rectangle 9",
  width: 2,
  height: 4,
  transform: "translate(-0.174)",
  fill: "#676767"
})));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  id: "Groupe_16",
  "data-name": "Groupe 16",
  transform: "translate(4.732 19.859)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Groupe_15",
  "data-name": "Groupe 15",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_10",
  "data-name": "Rectangle 10",
  width: 3,
  height: 2,
  transform: "translate(-0.174)",
  fill: "#676767"
})));

var _ref9 = /*#__PURE__*/React.createElement("g", {
  id: "Groupe_18",
  "data-name": "Groupe 18",
  transform: "translate(11.732 19.859)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Groupe_17",
  "data-name": "Groupe 17",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_11",
  "data-name": "Rectangle 11",
  width: 1,
  height: 2,
  transform: "translate(-0.174)",
  fill: "#676767"
})));

var _ref10 = /*#__PURE__*/React.createElement("g", {
  id: "Groupe_20",
  "data-name": "Groupe 20",
  transform: "translate(14.732 19.859)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Groupe_19",
  "data-name": "Groupe 19",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_12",
  "data-name": "Rectangle 12",
  width: 4,
  height: 2,
  transform: "translate(-0.174)",
  fill: "#676767"
})));

var _ref11 = /*#__PURE__*/React.createElement("g", {
  id: "Groupe_22",
  "data-name": "Groupe 22",
  transform: "translate(19.732 19.859)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Groupe_21",
  "data-name": "Groupe 21",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_13",
  "data-name": "Rectangle 13",
  width: 4,
  height: 2,
  transform: "translate(-0.174)",
  fill: "#676767"
})));

var _ref12 = /*#__PURE__*/React.createElement("g", {
  id: "Groupe_24",
  "data-name": "Groupe 24",
  transform: "translate(4.732 24.859)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Groupe_23",
  "data-name": "Groupe 23",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_14",
  "data-name": "Rectangle 14",
  width: 3,
  height: 4,
  transform: "translate(-0.174)",
  fill: "#676767"
})));

var _ref13 = /*#__PURE__*/React.createElement("g", {
  id: "Groupe_26",
  "data-name": "Groupe 26",
  transform: "translate(11.732 24.859)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Groupe_25",
  "data-name": "Groupe 25",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_15",
  "data-name": "Rectangle 15",
  width: 1,
  height: 4,
  transform: "translate(-0.174)",
  fill: "#676767"
})));

var _ref14 = /*#__PURE__*/React.createElement("g", {
  id: "Groupe_28",
  "data-name": "Groupe 28",
  transform: "translate(14.732 24.859)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Groupe_27",
  "data-name": "Groupe 27",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_16",
  "data-name": "Rectangle 16",
  width: 4,
  height: 4,
  transform: "translate(-0.174)",
  fill: "#676767"
})));

var _ref15 = /*#__PURE__*/React.createElement("g", {
  id: "Groupe_30",
  "data-name": "Groupe 30",
  transform: "translate(19.732 24.859)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Groupe_29",
  "data-name": "Groupe 29",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_17",
  "data-name": "Rectangle 17",
  width: 4,
  height: 4,
  transform: "translate(-0.174)",
  fill: "#676767"
})));

var _ref16 = /*#__PURE__*/React.createElement("g", {
  id: "Groupe_32",
  "data-name": "Groupe 32",
  transform: "translate(26.732 19.859)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Groupe_31",
  "data-name": "Groupe 31",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_18",
  "data-name": "Rectangle 18",
  width: 2,
  height: 2,
  transform: "translate(-0.174)",
  fill: "#676767"
})));

var SvgIcCalendar = function SvgIcCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "calendar",
    width: 32.664,
    height: 32.664,
    viewBox: "0 0 32.664 32.664",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_calendar.9d7c3a2c.svg";
export { ForwardRef as ReactComponent };